/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationMapIcon16Solid = forwardRef('LocationMapIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10 3.103 6 1.265v11.632l4 1.838V3.103Z" }),
        React.createElement("path", { d: "m11.25 14.298 3.188-1.555a1 1 0 0 0 .562-.9V2.16a.85.85 0 0 0-1.223-.764L11.25 2.63v11.669Z" }),
        React.createElement("path", { d: "M1.562 3.257 4.75 1.702v11.669l-2.527 1.233A.85.85 0 0 1 1 13.84V4.156a1 1 0 0 1 .562-.899Z" })));
});
